<template>
  <div class="index">
    <div v-if="healthBool" style="width: 100%;height: 100%;background: #fff;position:fixed;top:0;left:0">
      <img style="width: 100%;position: absolute;top: 50%;transform:translate(0,-50%)" src="../assets/imgs/health1.png" alt="" />
    </div>

    <div v-else>
      <Modal></Modal>
      <!-- 飘浮图标 -->
      <hover-icon></hover-icon>
      <!-- 跳转页面确认框 -->
      <open-confirm></open-confirm>
      <!-- 游戏内拍脸图 -->
      <PushPop></PushPop>
      <!-- 加载中 -->
      <Loading v-if="loading" class="ln-loading" size="50" type="spinner" vertical>加载中...</Loading>
      <!-- sdk红包按钮 -->
      <div v-show="rebateOpen" class="rebateBtn" ref="rebateIcon" :style="{ top: `${top}px` }" @touchstart="handleTouchStart"
      @touchmove.prevent="handleTouchMove" @click="openRebate">
        <img src="../assets/imgs/rebate.png" alt="">
      </div>
      <!-- 加载sdk红包链接 -->
      <div class="lngame_rebate" v-if="rebatePop">
        <van-popup v-model="show" :position="position" @close="closePop" :close-on-click-overlay="isOverlay" :style="rebateStyle" >
          <iframe :src="rebateUrl" ref="iframe"  style="width:100%;height:100%;overflow-y:scroll;background:#fff;" frameborder="0"></iframe>
        </van-popup>
        <van-popup v-model="kefu.show" position="bottom" close="closePopKefu" :style="{ height: '60%' }" >
          <div class="closeRebate" @click="closeIframeKefu"><van-icon size="40" name="cross" /></div>
          <iframe id="lnkefu" :src="kefu.url" style="width:100%;height:100%;overflow-y:scroll;" frameborder="0"></iframe>
        </van-popup>

        <div
          v-if="rebatePop"
          :style="rebateCloseStyle"
          style="position: absolute;left: 84.11%;z-index: 10001;"
          @click="closeBtn"
        >
          <img style="width: 30px" src="../assets/imgs/iconpull.png" alt="" />
        </div>
      </div>
    </div>
    
   
    <!-- 天剑 -->
    <div v-if="showCopyRight" style="position: fixed;bottom: -3px;left: 0;z-index: 99;width: 100%;text-align: center">
      <img :style="copyrightStyle" :src="currCopyRightUrl" alt="">
    </div>

  </div>
</template>

<script>
import { getUrlParams } from '@/utils';
import { mapState } from 'vuex';
import Modal from '@/components/Modal';
import HoverIcon from '@/components/HoverIcon';
import OpenConfirm from '@/components/OpenConfirm';
import { Loading } from 'vant';
import PushPop from '@/components/PushPop';
import draggable from '@/draggable';

import store from '@/store';
export default {
  name: 'Index',
  components: { Modal, HoverIcon, OpenConfirm, Loading, PushPop },
  data() {
    return {
      isRebate: false,
      show: true,
      kefushow: true,
      position: 'bottom',
      isOverlay: true,
      rebateCloseStyle: {
        top: '40%',
      },
      copyrightStyle: {
        width: '100%',
        height: '6.5vh'
      },
      currCopyRightUrl: '',
      copyrightImg: [
        {
          appid: ['68976', '68980', '68984'],
          url: require('../assets/imgs/tjfoot.jpg'), 
        },
        {
          appid: ['68952', '68956', '68960'],
          url: require('../assets/imgs/tjfoot2.jpg'), 
        },
        {
          appid: ['69044', '69048', '69052'],
          url: require('../assets/imgs/tjfoot3.jpg'), 
        },
        {
          appid: ['69166', '69170', '69174'],
          url: require('../assets/imgs/tjfoot4.jpg'), 
        },
        {
          appid: ['69376', '69380', '69384'],
          url: require('../assets/imgs/tjfoot5.jpg'), 
        },
        {
          appid: ['70584', '70588', '70592'],
          url: require('../assets/imgs/tjfoot8.jpg'), 
        },
        {
          appid: ['71288', '71292', '71296'],
          url: require('../assets/imgs/tjfoot9.jpg'), 
        },
        {
          appid: ['71812', '71816', '71820'],
          url: require('../assets/imgs/tjfoot10.jpg'),
        }
      ],
      top: 300, // 初始位置
      startY: 0,
      startTop: 0,
      buttonHeight: 51
    };
  },
  computed: {
    ...mapState(['loading', 'rebateOpen', 'rebateUrl', 'kefu', 'rebatePop', 'healthBool', 'verticalRb', 'showCopyRight'])
  },
  mounted() {
    // if (this.rebateOpen) {
        // this.setDrag();
    // }
    // 根据应用组显示对应的版号信息图片
    this.copyrightImg.forEach(item => {
      if (item.appid.includes(getUrlParams('appid'))) {
        this.currCopyRightUrl = item.url
      }
    })
    const isAndroid = /Android/i.test(navigator.userAgent);
    if (isAndroid) {
      this.copyrightStyle.height = '9vh'
    } else if (window.innerWidth > 1366) {
      this.copyrightStyle.width = '835px'
    }
    
  },
  watch: {
    verticalRb(val) {
      if (this.verticalRb == 1) {
        this.rebateStyle = { height: '100%', width: '84.11%', overflow: 'hidden' };
        this.rebateCloseStyle = { top: '0%' };
        this.position = 'left';
        this.isOverlay = false;
      }
    },
  },
  created() {
  },
  methods: {
    reload() {
      location.reload();
    },
    openRebate() {
      this.isRebate = true;
      this.show = true;
      store.commit('SET_RABTOPEN', true);
      // console.log(this.rebateUrl)
      // store.commit('SET_REBATEURL', this.rebateUrl);
      this.$nextTick(() => {
        this.$refs.iframe.src = this.rebateUrl
      })
    },
    closePop() {
      this.show = false;
      this.$refs.iframe.src = '';
    },
    closeBtn() {
      store.commit('SET_RABTOPEN', false);
    },
    closePopKefu() {
      store.commit('SET_OPENKEFU', {show: false});
    },
    closeIframeKefu() {
      store.commit('SET_OPENKEFU', {show: false});
    },
    closeIframe() {
      this.isRebate = false;
      // store.commit('SET_OPEN', true);
    },
    closeWxTip() {
      this.wxTip = false;
    },
    // 红包按钮拖动
    setDrag() {
      const el = this.$refs.rebateIcon;
      console.log(111111)
      const { clientWidth, clientHeight } = document.documentElement;
        // 移动端的拖动
          draggable(el, {
            drag: e => {
              const touch = e.changedTouches[0];
              // 定位到元素中间
                const EL_MIDDLE = el.clientHeight / 2;
                let top = touch.clientY - EL_MIDDLE;
                const minTop = 0;
                const maxTop = clientHeight - el.clientHeight;
                const resultTop = Math.min(Math.max(minTop, top), maxTop);
                if (clientHeight <= 0) {
                  if (top <= 0) top = 0;
                  el.style.top = `${top}px`
                } else {
                  el.style.top = `${resultTop}px`;
                }
                console.log(resultTop)
            }
          });
    },
    handleTouchStart(e) {
        this.startY = e.touches[0].clientY
        this.startTop = this.top
      },
      handleTouchMove(e) {
        const clientY = e.touches[0].clientY
        const deltaY = clientY - this.startY
        
        // 计算新位置并限制边界
        let newTop = this.startTop + deltaY
        newTop = Math.max(0, newTop) // 不能超过顶部
        newTop = Math.min(window.innerHeight - this.buttonHeight, newTop) // 不能超过底部
        this.top = newTop;
    }
  }
};
</script>
<style lang="scss">
/* @import url() */
// 加载中
.ln-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
// .lngame_rebate{position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.6);z-index: 900;}
.rebateBtn{
  position: absolute;
  left: 0;
  top: 50%;
  z-index: 901;
}
#lnkefu #mobile .mobile-header .goBack{display: none!important;}
.rebateBtn img{width: 40px;}
.closeRebate{position: absolute;top: 2px;left: 1px;z-index: 999;opacity: 0}

</style>
